<template>
  <footer class="t-footer">
    <div class="t-footer__accesskey">
      <AccesskeyLink accesskey="Z" to="#footer" title="頁尾" id="footer" />
    </div>
    <div class="t-footer__links">
      <span>
        <router-link
          :to="{ name: 'sitemap' }"
          aria-label="網站導覽"
          title="[前往]網站導覽"
        >
          網站導覽
        </router-link>
      </span>
      <span v-for="(link, linkIndex) in friendLinks" :key="linkIndex">
        <a
          :href="link.url"
          target="_blank"
          v-text="link.name"
          :title="`[另開新分頁]前往${link.name}`"
        />
      </span>
    </div>
    <div class="t-footer__government">
      <a
        href="https://www.twtainan.net"
        target="_blank"
        aria-label="前往臺南市政府觀光旅遊局，將另開新分頁。"
        title="[另開新分頁]前往臺南市政府觀光旅遊局"
      >
        <img
          :src="tainanSvg"
          alt="臺南市政府觀光旅遊局"
          class="t-footer__government__image"
          :srcset="
            require(`@/assets/images/footer/logo_tainan@1x.png`) +
            ' 1x, ' +
            require(`@/assets/images/footer/logo_tainan@2x.png`) +
            ' 2x'
          "
        />
      </a>

      <a
        href="https://accessibility.moda.gov.tw/Applications/Detail?category=20230727143756"
        title="無障礙網站"
        class="t-footer__government__a11y-cert"
      >
        <img
          :src="accessibilityCertificate"
          border="0"
          width="88"
          height="31"
          alt="通過A檢測等級無障礙網頁檢測"
        />
      </a>
    </div>
    <section class="t-footer__copyright">
      <div class="t-footer__copyright__section">
        <div>台南市政府觀光旅遊局</div>
        <div>73001 台南市新營區民治路36號</div>
      </div>
      <div class="t-footer__copyright__section">
        <div>本網站圖文資料未經授權請勿使用</div>
        <div>Copyright &copy; {{ thisYear }} All Rights Reserved</div>
      </div>
      <div class="t-footer__copyright__section">
        <div>最佳瀏覽狀態為</div>
        <div>Google Chrome ‧ Firefox ‧ IE 11.0 以上</div>
      </div>
    </section>
  </footer>
</template>

<script>
import AccesskeyLink from '@/components/a11y/AccesskeyLink';
import tainanSvg from '@/assets/images/footer/logo_tainan@2x.png';
import accessibilityCertificate from '@/assets/images/footer/accessibility-certificate.jpg';
import { friendLinks } from '@/config/friendLinks';

export default {
  name: 'TheFooter',
  props: {},
  data() {
    return {};
  },
  computed: {
    tainanSvg() {
      return tainanSvg;
    },
    friendLinks() {
      return friendLinks;
    },
    accessibilityCertificate() {
      return accessibilityCertificate;
    },
    thisYear() {
      return new Date().getUTCFullYear();
    },
  },
  methods: {},
  components: { AccesskeyLink },
};
</script>

<style lang="scss" scoped>
.t-footer {
  color: $color-footer-text;
  background: $color-footer-bg;
  text-align: center;
  padding: 20px 30px;
  font-size: 14px;

  &__accesskey {
    text-align: left;
  }

  &__links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 5px;

    a {
      display: inline-block;
      color: $color-footer-text;
      font-size: inherit;
      border-left: 1px solid $color-footer-text;
      border-right: 1px solid $color-footer-text;
      padding: 0 0.5rem;
      margin: 0 10px 1rem;
      flex: 1 1 auto;

      &:hover {
        color: $color-link;
      }
    }
  }

  &__government {
    position: relative;

    a {
      display: inline-block;

      &.t-footer__government__a11y-cert {
        display: none;

        @include for-tablet {
          position: absolute;
          right: 100px;
          top: 20px;
          bottom: 0;
          display: inline-flex;
          align-content: center;
          align-items: center;
        }
      }
    }

    &__image {
      width: 124px;
    }
  }

  &__copyright {
    font-size: inherit;
    line-height: 1.6;
    margin: 1.5rem auto 0;

    @include for-desktop {
      max-width: 100%;
    }

    &__section {
      padding: 8px 0;

      div {
        @include for-tablet {
          display: inline-block;
          margin: 0 5px;
        }
      }
    }
  }
}
</style>
